// extracted by mini-css-extract-plugin
module.exports = {"SelectNavigation":"styles_SelectNavigation__vb2uu","select":"styles_select__HRwOq","icon":"styles_icon__1SegE"};